import React from 'react';
export function FeaturesSection() {
  return <div className="space-y-16 mb-20" data-id="element-1081">
      {/* Feature 1 */}
      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-1082">
        <div data-id="element-1083">
          <h3 className="text-2xl md:text-3xl font-bold text-[#9B0137] uppercase tracking-wide mb-6" data-id="element-1084">
            MACHINE LEARNING AND ARTIFICIAL INTELLIGENCE
          </h3>
          <p className="text-lg text-gray-700 leading-relaxed" data-id="element-1085">
            It uses <strong data-id="element-1086">machine learning algorithms</strong> and{' '}
            <strong data-id="element-1087">advanced artificial intelligence systems</strong> to achieve
            high-level mechanical and aesthetic properties innovating and
            evolving 3D printing.
          </p>
        </div>
        <div className="order-first md:order-last" data-id="element-1088">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Breton/Breton%20additive-manufacturing%20-%20artificial%20intelligence.jpg" alt="Machine Learning and AI" className="block w-full h-auto rounded-xl shadow-lg" data-id="element-1089" />
        </div>
      </div>

      {/* Feature 2 */}
      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-1090">
        <div data-id="element-1091">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Breton/Genesi%20Thermoplastic%20Printer%20-%20Giant%20Dimensions.jpg" alt="Giant Dimensions" className="block w-full h-auto rounded-xl shadow-lg" data-id="element-1092" />
        </div>
        <div data-id="element-1093">
          <h3 className="text-2xl md:text-3xl font-bold text-[#9B0137] uppercase tracking-wide mb-6" data-id="element-1094">
            GIANT IN DIMENSIONS
          </h3>
          <p className="text-lg text-gray-700 leading-relaxed" data-id="element-1095">
            <strong data-id="element-1096">"Giant" in dimensions</strong>, Genesi is one of the world's
            largest 3D printers for prototyping (
            <strong data-id="element-1097">
              3 metres in height, up to 5 metres in width and length on request
            </strong>
            ) with a deposition capacity up to 200 kg per hour of reinforced
            thermoplastic materials.
          </p>
        </div>
      </div>

      {/* Feature 3 */}
      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-1098">
        <div data-id="element-1099">
          <h3 className="text-2xl md:text-3xl font-bold text-[#9B0137] uppercase tracking-wide mb-6" data-id="element-1100">
            COMBINATION OF ADDITIVE AND SUBTRACTIVE SYSTEMS
          </h3>
          <p className="text-lg text-gray-700 leading-relaxed" data-id="element-1101">
            <strong data-id="element-1102">
              Genesi can operate either in a purely additive version or in
              combination with a subtractive system
            </strong>
            . This second solution overcomes the limits of the pure additive
            method, which allows the production of near net shape parts that are
            close to the final shape but not completely finished.
          </p>
        </div>
        <div className="order-first md:order-last" data-id="element-1103">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Breton/Breton%20Genesi%20additive_subtractive-manufacturing.jpg" alt="Additive and Subtractive Systems" className="block w-full h-auto rounded-xl shadow-lg" data-id="element-1104" />
        </div>
      </div>
    </div>;
}